import { useCallback } from 'react'

import { resetNotificationEmailCounter } from '@/features/domain/account'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useController } from './useController'

export function useResetNotificationEmailCounter() {
  const { update, close } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnmounted = useIsUnmounted()

  return useCallback(async () => {
    try {
      update({ status: 'submitting' })

      const thunkResult = await dispatch(resetNotificationEmailCounter())

      if (!resetNotificationEmailCounter.fulfilled.match(thunkResult)) {
        throw new Error(thunkResult.payload?.message ?? 'Internal error')
      }

      if (isUnmounted()) return

      close?.()
    } catch (e) {
      toast.error(e.message)
      update({ status: 'ready' })
    }
  }, [dispatch, toast, close, update, isUnmounted])
}
